export enum SaveNHSTokenRegistrationErrorType {
    None = 1,
    Validation,
    Unknown,
    Popup,
    NonceMismatch
}

export enum SaveNHSTokenRegistrationPatientAction {
    None = 1,
    LoggedIn,
    LogIn,
    CompleteRegistration
}

export interface CompleteRegistrationData {
    firstName: string;
    lastName: string;
    dateOfBirth?: Date;
    email: string;
}

export interface NhsRegistrationResponse {
    success: boolean;
    errorType: SaveNHSTokenRegistrationErrorType;
    errorMessage: string;
    patientAction: SaveNHSTokenRegistrationPatientAction;
    completeRegistrationData: CompleteRegistrationData;
    nhsNumber: string;
    isPatientUpdated?: boolean;
    notLinkedWithIM1?: boolean;
}
